import React, { useState, useEffect } from 'react'
import SubHeader from '../general/SubHeader'
import ScrollAnimation from 'react-animate-on-scroll';
import subimg1 from '../assets/subimg-1.jpg'
import subimg2 from '../assets/subimg-2.jpg'
import subimg3 from '../assets/subimg-3.jpg'
import subimg4 from '../assets/subimg-4.jpeg'
import subimg5 from '../assets/subimg-5.jpeg'
import subimg6 from '../assets/subimg-6.jpg'


const Academics = ({ setResponse, setLoading }) => {
  const [notice, setNotice] = useState([]);
  useEffect(() => {

    const fetchNotice = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcian.in/get-notice');

        if (response.ok) {
          const data = await response.json();
          data.sort((a, b) => new Date(b.date) - new Date(a.date));
          setNotice(data);
          setLoading(false);
        } else {
          setLoading(false);
          console.error('Failed to fetch coupon');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };

    fetchNotice();
  }, []);

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };
  //   const [showAch, setShowAch] = useState(false);
  // const [formData, setFormData] = useState({
  //   tagline: '',
  //   description: '',
  //   image: null,
  //   status: 'Unapproved',
  //   added_by: ''
  // })


  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setFormData({ ...formData, image: file });
  //   }
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const payload = new FormData();
  //   payload.append('tagline', formData.tagline);
  //   payload.append('description', formData.description);
  //   payload.append('image', formData.image);
  //   payload.append('status', formData.status || 'Unapproved');
  //   payload.append('added_by', formData.added_by);

  //   setLoading(true);

  //   try {
  //     const response = await fetch('https://api.kcian.in/add-achievement', {
  //       method: 'POST',
  //       body: payload,
  //     });

  //     if (response.ok) {
  //         setLoading(false);
  //       setShowAch(false);
  //       setFormData({ tagline: '', description: '', image: null, status: 'Unapproved' });
  //        setResponse({ message: 'Achievement submitted! Wait for Approval to display on Website.', status: 'success' });
  //       setTimeout(() => setResponse(''), 3000);
  //     } else {
  //         setLoading(false);      
  //        setResponse({ message: 'Something went wrong. Try again later.', status: 'success' });
  //       setTimeout(() => setResponse(''), 2000);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting achievement:", error);
  //         setLoading(false);
  //   }
  // };


  return (
    <>
      {/* <SubHeader message="Academics" /> */}
      {/* safely-measures */}
      <ScrollAnimation animateIn='fadeInUp'>
        <div className='safely-measures1'>
          <h2 >ACADEMICS</h2>
          <p>"KC Public School offers a well-structured academic program that blends strong foundational learning with innovative teaching methods. <br></br>Our dedicated faculty fosters curiosity, critical thinking, and creativity, ensuring students excel in every subject<br></br> while preparing for future academic and personal success."</p>

        </div>
      </ScrollAnimation>
      {/*end safely-measures */}

      {/* 2-cards */}
      {/* <div className='main-section'>
                <div className='first-section'>
                  <div className='image-section'>
                    <img src={Banner1} alt=''></img>
                  </div>
                  <div className='description-section'>
                    <h3>Student Life</h3>
                    <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font. </p>
                    <button>Student information</button>
                  </div>
                </div>
                <div className='second-section'>
                  <div className='description-section'>
                    <h3>Open Enrollment</h3>
                    <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font. </p>
                    <button>Apply Today</button>
                  </div>
                  <div className='image-section'>
                    <img src={Banner2} alt=''></img>
                  </div>
                </div>
              </div> */}
      <div className='main-course-container'>
        <div className='first-row'>
          <div className='row-img'>
            <img src={subimg1} />
          </div>
          <div className='row-description'>
            <h2>Social Studies</h2>
            <p>Social studies is the study of individuals, communities, systems, and their interactions across time and place that prepares students for local, national, and global civic life.</p>
          </div>
          <div className='row-img'>
            <img src={subimg2} />
          </div>
          <div className='row-description'>
            <h2>Science</h2>
            <p>Science is the pursuit and application of knowledge and understanding of the natural and social world following a systematic methodology based on evidence.</p>
          </div>
        </div>
        <div className='second-row'>
          <div className='row-description'>
            <h2>Math</h2>
            <p>Buy Mathematics Definition, Maths Poster, Graduation Gift ...Mathematics is the study of numbers, quantities, shapes, and their relationships.</p>
          </div>
          <div className='row-img'>
            <img src={subimg3} />
          </div>
          <div className='row-description'>
            <h2>Literature Arts</h2>
            <p>Literature, or literary arts, encompasses a broad range of written works, particularly those considered to be art forms like novels, plays, and poetry.</p>
          </div>
          <div className='row-img'>
            <img src={subimg4} />
          </div>
        </div>
        
        <div className='first-row'>
          <div className='row-img'>
            <img src={subimg5} />
          </div>
          <div className='row-description'>
            <h2>Art</h2>
            <p>Art is a diverse range of human activities involving creative or imaginative talent, producing works that are intended to be appreciated for their beauty, emotional power, or conceptual ideas.</p>
          </div>
          <div className='row-img'>
            <img src={subimg6} />
          </div>
          <div className='row-description'>
            <h2>Physical Education</h2>
            <p>Physical education (PE) is a structured educational course focused on improving physical fitness and health through movement and physical activity.</p>
          </div>
        </div>
        

      </div>
      {/*end 2-cards */}



      {/* notices section */}
      <section className='my-5'>
        <div className='container'>

          <p className='about-heading'>Notices</p>

          <div className='notice-area'>

            {notice && notice.length > 0 ? (
              notice.slice(0, 3).map((notices, index) => (
                <div key={index} className='my-3 border-bottom'>
                  <p className='fw-bold fm-mont my-1'>{notices.tagline}</p>
                  <p className='para-text text-muted fw-semibold'>Date Posted On: {formatDateTime(notices.date)}</p>
                  <p className='text-muted fm-mont para-text'>Details: {notices.description}</p>
                </div>
              ))
            ) : (
              <p className='my-3 text-muted'>There are currently no notices to display. Please check back later for updates.</p>
            )}

          </div>
          {/* notice area ends */}

        </div>
      </section>
      {/* notices section ends */}


      {/* achievements section */}
      {/* <section className='my-5'>
  <div className='container'>


<div className='d-md-flex justify-content-between d-block'>
<p className='about-heading'>Achievements</p>
<button className='carousel-btn para-text px-3 py-2 cursor-pointer' onClick={() => setShowAch(true)}>Add Your Achievement <i class="fa-solid fa-graduation-cap"></i></button>
</div>

<div className='row mt-4'>

<div className='col-lg-3 my-2'>
<img src={Course1} className='img-fluid w-100' alt='achievements' />
</div>


<div className='col-lg-9 my-2'>
  <p className='fs-5 fw-bold'>School Excellence Award</p>
  <hr />
  <p className='text-muted'>The School Excellence Award is a prestigious recognition given to educational institutions that demonstrate outstanding performance across various dimensions of school operations. This award celebrates schools that not only achieve academic success but also excel in fostering holistic development, innovation, and community involvement.</p>
  <p className='text-muted'>Award for the third consecutive year, acknowledging our commitment to academic brilliance, innovative teaching, and holistic student development. This award motivates us to continue striving for higher standards and deeper community impact.</p>
</div>


<div className='col-lg-3 my-2'>
<img src={Course2} className='img-fluid w-100' alt='achievements' />
</div>


<div className='col-lg-9 my-2'>
  <p className='fs-5 fw-bold'>The school has received Special Recognition from HRD Minisrty for its results.</p>
  <hr />
  <p className='text-muted'>Our school has been honored with Special Recognition from the Ministry of Human Resource Development (HRD) in acknowledgment of our exemplary academic results. This prestigious recognition reflects the dedication, hard work, and commitment of our students, teachers, and management toward achieving excellence in education.</p>
  <p className='text-muted'>This special recognition is a testament to our consistent record of high pass percentages, top ranks, and outstanding student achievements in board examinations and other academic assessments.</p>
</div>

</div>

  </div>
</section> */}
      {/* achievements section ends */}


      {/* alumni section */}
      <section className='my-5'>
        <div className='container'>

          <p className='about-heading'>Our Alumni</p>

          <p className='fw-bold'>Session Year 2024 - 2025</p>

          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                  Grade 12th
                </button>
              </h2>
              <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body"></div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                  Grade 11th
                </button>
              </h2>
              <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body"></div>
              </div>
            </div>
          </div>


          <p className='fw-bold'>Session Year 2023 - 2024</p>

          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne1">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne1" aria-expanded="false" aria-controls="flush-collapseOne1">
                  Grade 12th
                </button>
              </h2>
              <div id="flush-collapseOne1" class="accordion-collapse collapse" aria-labelledby="flush-headingOne1" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body"></div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingTwo1">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo1" aria-expanded="false" aria-controls="flush-collapseTwo1">
                  Grade 11th
                </button>
              </h2>
              <div id="flush-collapseTwo1" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo1" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body"></div>
              </div>
            </div>
          </div>

        </div>
      </section>
      {/* alumni section ends */}



    </>
  )
}

export default Academics
